import React, { useEffect, useState, useRef } from "react";
import ReactDataTables from "../../customComponents/ReactDataTables";
import CustomDataTableBase from "../../customComponents/customTable";

const MetricDetailsListView = ({
  clickedRow,
  autoAQMetric,
  metricdetailspopupListview,
}) => {
  const { is_autoqametric, metric_details_popup_contactType_display } =
    autoAQMetric;
  const COlName = metricdetailspopupListview?.[0] || {};
  const filteredList = metricdetailspopupListview?.filter(
    (x) => parseFloat(x.Calls) !== 0,
  );
  const hasData = Array.isArray(filteredList) && filteredList.length > 0;
  const isAutoQA = is_autoqametric === "Y";
  const columns = [
    {
      title: metric_details_popup_contactType_display?.trim() || "contact type",
      data: "queName",
      render: (data) => `<span class="text-left">${data}</span>`,
    },
    // {
    //   title: COlName.callsDisplayName || "activity count",
    //   data: "calls",
    //   render: (data, type, row) => parseFloat(data),
    // },
    {
      title: COlName.actualDisplayName || "actual",
      data: "actual",
      render: (data, type, row) => parseFloat(data),
    },
    {
      title: COlName.goalDisplayName || "goal",
      data: "goal",
      render: (data, type, row) => parseFloat(data),
    },
    // {
    //   title: "Priority Value",
    //   data: "priority_Value",
    //   render: (data, type, row) => parseFloat(data),
    // },
    {
      title: "Coaching priority",
      data: null,
      render: (data, type, row, meta) => meta.row + 1,
    },
  ];

  const BlankDataColumns = [
    {
      title: metric_details_popup_contactType_display?.trim() || "contact type",
      data: null,

      render: function (data, type, row) {
        return `<span class="text-left">${data ?? ""}</span>`;
      },
    },

    {
      title: "actual",
      data: null,
    },
    {
      title: "goal",
      data: null,
    },
    {
      title: "variance",
      data: null,
    },

    {
      title: "Coaching priority",
      data: null,
    },
  ];

  return (
    <div className="">
      {hasData ? (
        <ReactDataTables
          key="datatable-with-data"
          columns={columns}
          data={filteredList}
        />
      ) : (
        <ReactDataTables
          key="datatable-no-data"
          columns={BlankDataColumns}
          data={[]}
        />
      )}
    </div>
  );
};

export default MetricDetailsListView;
